import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardHeader from '../../../../components/DashboardHeader';
import DashboardFooter from '../../../../components/DashboardFooter';
import { 
  FaUserPlus, 
  FaUsers, 
  FaCreditCard,
  FaCogs,
  FaLock
} from 'react-icons/fa';
import { auth, db } from '../../../../auth/firebase';
import { doc, updateDoc } from 'firebase/firestore';
import cacheManager from '../../../../auth/cache_manager';
import './tech_board.css';

const TechBoard = () => {
  const navigate = useNavigate();
  const [isDarkMode, setIsDarkMode] = useState(false);

  // # Load theme preference from user data on initial render
  useEffect(() => {
    const loadThemePreference = async () => {
      if (auth.currentUser?.uid) {
        // # Try to get from cache first
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData && userData.themes && userData.themes.gen_theme !== undefined) {
          setIsDarkMode(userData.themes.gen_theme === 'dark');
        }
      }
    };
    
    loadThemePreference();
  }, []);

  // # Handle theme toggle
  const handleThemeToggle = async () => {
    try {
      const newTheme = !isDarkMode;
      setIsDarkMode(newTheme);
      
      // # Update theme in Firebase if user is logged in
      if (auth.currentUser?.uid) {
        // # Update the user document
        await updateDoc(doc(db, 'users', auth.currentUser.uid), {
          'themes.gen_theme': newTheme ? 'dark' : 'light'
        });
        
        // # Update cache manager
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData) {
          const updatedUserData = {
            ...userData,
            themes: {
              ...(userData.themes || {}),
              gen_theme: newTheme ? 'dark' : 'light'
            }
          };
          cacheManager.set(`user_${auth.currentUser.uid}`, updatedUserData);
        }
      }
    } catch (error) {
      console.error('Error updating theme preference:', error);
    }
  };

  // # Define tech board sections with navigation paths
  const sections = [
    {
      title: 'On-creates',
      icon: <FaUserPlus />,
      path: '/admin/tech-board/oncreate'
    },
    {
      title: 'Users',
      icon: <FaUsers />,
      path: '/admin/tech-board/users'
    },
    {
      title: 'Subscriptions',
      icon: <FaCreditCard />,
      path: '/admin/tech-board/subscriptions'
    },
    {
      title: 'Locked Content',
      icon: <FaLock />,
      path: '/admin/tech-board/locks'
    },
    {
      title: 'Other Functions',
      icon: <FaCogs />,
      path: '/admin/tech-board/other'
    }
  ];

  // # Handle section click
  const handleSectionClick = (path) => {
    navigate(path);
  };

  return (
    <div className={`tech_brd_container ${isDarkMode ? 'tech_brd_dark-mode' : ''}`}>
      <DashboardHeader isDarkMode={isDarkMode} onThemeToggle={handleThemeToggle} />
      
      <main className="tech_brd_content">
        <div className="tech_brd_header">
          <h1>Technical Board</h1>
          <p>System management and technical operations</p>
        </div>

        <div className="tech_brd_sections-grid">
          {sections.map((section, index) => (
            <div 
              key={index} 
              className="tech_brd_section-card"
              onClick={() => handleSectionClick(section.path)}
            >
              <div className="tech_brd_icon-container">
                {section.icon}
              </div>
              <h2>{section.title}</h2>
            </div>
          ))}
        </div>
      </main>

      <DashboardFooter isDarkMode={isDarkMode} />
    </div>
  );
};

export default TechBoard;
